import { useEffect, useState } from 'react';
import { Modal, message, Form, Button, InputNumber, Alert } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import API from "../../../../services/API";
import { PAYMENT_PRODUCT_TYPE } from "../../../../constants/AppConstants";
import LoaderComponent from '../../../Loader';


export default function PaymentLinkCheckoutModal({ userId, ccAccountId, ccData, refreshList }) {
  const labelCol = {span: 12};
  const [amount, setAmount] = useState(10);
  
  const [modalVisible, setModalVisible] = useState(false);
  const [modalLoading, showModalLoading] = useState(false);
  const [areStatementsAvailable, setAreStatementsAvailable] = useState(false);
  const [paymentLink, setPaymentLink] = useState(false); // 'https://pay.sandbox.checkout.com/link/pl_nACQLvD_6NZD'

  useEffect(() => {
    if (ccData?.accountDetails?.paymentDue) {
      setAreStatementsAvailable(true);
      setAmount(parseFloat(ccData?.accountDetails?.paymentDue).toFixed(2));
    }
  }, [ccData]);

  const copyPaymentLink = () => {
    if (paymentLink && navigator?.clipboard) {
      navigator.clipboard.writeText(paymentLink);
      message.success('Copied link to clipboard!')
    }
  }

  const showModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    // Refresh on close, because refreshing earlier would close the new link
    if (paymentLink && refreshList) refreshList();
  }

  const onFinishFailed = (error) => {
    console.log('new error', { ...error});
  };

  const createPaymentLink = async (data) => {
    console.log('createPaymentLink', data);
    
    showModalLoading(true);
    API.postCreatePaymentLink({
      userId,
      ccAccountId,
      amountInCents: Math.round(parseFloat(data.amount) * 100),
      product: PAYMENT_PRODUCT_TYPE.CREDIT_CARD
    }).then((resp) => {
      showModalLoading(false);
      setPaymentLink(resp);
    }).catch((error) => {
      alert(error?.message || 'Something went wrong')
      showModalLoading(false);
    });
  }

  return (
    <>
      <Button type="primary" className={'card-bottom-buttons'} onClick={showModal}>
        Generate Payment Link (Checkout) 
      </Button>
      <div style={{clear: "both"}}></div>
      <Modal
        title={'Generate Payment Link'}
        centered
        mask={true}
        maskClosable={true}
        destroyOnClose={true}
        closable={false}
        open={modalVisible}
        footer={null}
        className="confirm-modal"
      >
        <>
          <Form
            name="basic"
            labelCol={{
              span: 8,
            }}
            wrapperCol={{
              span: 16,
            }}
            style={{
              maxWidth: 600,
            }}
            initialValues={{
              amount
            }}
            onFinish={createPaymentLink}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            
            <div>
              <Form.Item
                label="Payment Amount ($)"
                labelCol={labelCol}
                name="amount"
                extra={<small>(Default) This value is set to the current balance of the last statement</small>}
                rules={[
                  {
                    required: true,
                    message: 'Please enter an amount',
                  },
                  {
                    validator: (_, value) =>
                      value && value >= 1 ? Promise.resolve() : Promise.reject(new Error('Please enter an amount greater than $1')),
                  }
                ]}
                disabled={modalLoading}
              >
                <InputNumber max={10000} step="0.01"/>
              </Form.Item>
            </div>
            <div>
              {/* { isLastPaymentMade && <Alert message="The user has already paid some amount in their last statement. Please see the last statement below." type="warning" /> } */}
              { !areStatementsAvailable && <Alert message="The user might not have any statements generated for credit cards. Please see the statements below. You can still generate payment links." type="error" /> }
              { paymentLink && <Alert message={
                  <>
                    <b>Payment Link: </b>
                      {paymentLink}
                      <small> <CopyOutlined onClick={copyPaymentLink} style={{ cursor: 'pointer'}}/></small>
                  </>
                } type="success" /> }
              <div>&nbsp;</div>
            </div>
            <div>
                <Form.Item >
                <Button type="primary" htmlType="submit" disabled={modalLoading}>
                  Create
                </Button>
                &nbsp;
                <Button htmlType="button" onClick={closeModal} disabled={modalLoading}>
                  Close
                </Button>
                </Form.Item>
            </div>
          </Form>
          {modalLoading && <LoaderComponent />}
        </>
      </Modal>
    </>
  )
}